import React, { useContext, useEffect, useRef, useState } from 'react';
import useCollapse from 'react-collapsed';
import { config } from '@fortawesome/fontawesome-svg-core'
import { faSwimmingPool, faLocationDot } from '@fortawesome/pro-regular-svg-icons'
import { faBed as fasBed, faHotTub as fasHotTub, faShower as fasShower, faUsers as fasUsers } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';
import Methods from '../../../../../../helpers/class/Methods';

import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false;

import { useInViewport } from 'react-in-viewport';
import { useSelector } from 'react-redux';

import * as appContext from '../../../../../AppContext';
import ReadMoreText from '../../../../../ReadMoreText';
import Skeleton from 'react-loading-skeleton';

export default function PropertyHeadingTop ( props ) {
  const [ isPublicDomain, setIsPublicDomain ] = useState( useSelector( state => state['appSettings']['isPublicDomain']) )
  const [ publicDomain, setPublicDomain ] = useState( 0 );

  const bookingBedrooms = useSelector(state => state['singlePropertyData']['bookingBedrooms'])

  const isHotel = useSelector(state => state['appSettings']['isHotel'])

  const roomTypes = bookingBedrooms ? bookingBedrooms.length + '' : 0

  useEffect( () => {
    setPublicDomain( isPublicDomain )
  }, [ isPublicDomain, setPublicDomain ])
    
  const config = { disconnectOnLeave: false };
  const options = {  };
  const myRef = useRef();
  const {
    inViewport
  } = useInViewport(
    myRef,
    options,
    config,
    props
  );

  const array = isHotel ? [{ key: 'room_types', value: roomTypes + ' room types' }] : [
    { key: 'guests', value: props.details.capacity },
    { key: 'bedrooms', value: props.details.bedrooms },
    { key: 'bathrooms', value: props.details.bathrooms },
    { key: 'pools', value: props.details.pools },
    { key: 'jacuzzi', value: props.details.jacuzzi },
  ];

  const [ isExpanded, setExpanded ] = React.useState( false );
  const { getCollapseProps } = useCollapse({
    isExpanded
  });

  const [ propertyTitle, setPropertyTitle ] = useState( props.details.property_title )

  const alternative_title = props.details.alternative_title

  useEffect( () => {
    if ( alternative_title != undefined && publicDomain==1 ) {
      if ( alternative_title.length>0 ) {
        setPropertyTitle( alternative_title )
      }
    }
  }, [ publicDomain, setPropertyTitle, alternative_title ])

  // useEffect( () => {
  //   console.log("props.location", props.location)
  // })

  let viewPortResult = null;
  // if(!inViewport){
  //     viewPortResult =
  //         <>
  //             <Skeleton height={30} className="col-8 col-sm-6 col-md-4 b-rad-md mb-1" />
  //             <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
  //             <Skeleton height={30} className="col-12 col-sm-8 col-md-6 b-rad-md mb-1"/>
  //             <Skeleton height={150} className="col-12 b-rad-lg"/>
  //         </>
  //     ;
  // } else {

  let dotsFlag = false

  viewPortResult =
    <>
      <section className="jumbotron" data-pages="parallax" data-bg-overlay="white" data-overlay-opacity="0.8" style={{backgroundColor: "#f0f0f0"}}>
        <div className="inner">
          <div className="container-xs-height">
            <div className="col-xs-height col-middle text-left">
              <div className="container">
                <div className={'row'}>
                  <div className="col-md-12 no-padding col-xs-12 p-t-40 p-b-50">
                    {
                        (Checkers.isValidString( props.location.address ) || Checkers.isValidString( props.location.address ) ) &&
                        <h5 className="block-title sm-text-center m-b-0">
                          <FontAwesomeIcon icon={faLocationDot} className={'m-r-10'}/>
                          {Checkers.isValidString( props.location.address ) && props.location.address}
                          {Checkers.isValidString( props.location.address ) && ',\ ' + props.location.city}
                        </h5>
                    }
                    <h1 className="light sm-text-center m-t-0">{propertyTitle}</h1>
                    <p className="sm-text-center">
                      {
                        array.map( ( item, index ) => {
                          if ( Checkers.isValidString( item.value ) ) {
                            return (
                              <span aria-hidden="true" key={item.key.toString()}>
                                {isHotel && roomTypes === 0 ? (
                                  <Skeleton height={25} width="100%" />
                                ) : (
                                  <>
                                    {dotsFlag && Checkers.isValidString( item.value ) && index > 0 && (
                                        <span aria-hidden="true" key={'dot-' + index}> · </span>
                                    )}
                                    <FontAwesomeIcon
                                      icon={
                                        item.key === 'guests' ? fasUsers
                                        : item.key === 'bedrooms' ? fasBed
                                        : item.key === 'bathrooms' ? fasShower
                                        : item.key === 'jacuzzi' ? fasHotTub
                                        : item.key === 'room_types' ? fasBed
                                        : faSwimmingPool
                                      }
                                      className="text-master m-r-5"
                                    />
                                    {item.value}
                                    {
                                      dotsFlag = true
                                    }
                                    {/*{index < array.length - 1 && (*/}
                                    {/*    <span aria-hidden="true" key={'dot-' + index}> · </span>*/}
                                    {/*)}*/}
                                  </>
                                )}
                              </span>
                            );
                            
                          }
                        })
                      }
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  ;
  // }

  return (
    <div ref={myRef} id="pro_detail_desc" className="row full-width no-margin">
      { viewPortResult }
    </div>
  )
}
